interface SurveyQuestion {
  id: number
  text: string
  type: string
  isRequired?: boolean
  maxSelections?: number
  component?: string
  responses?: Array<{
    id: number
    text: string
    nestedQuestions?: SurveyQuestion[]
  }>
  hideText?: boolean
}

interface SurveyQuestionResponse {
  id?: number
  surveyQuestionId: number
  surveyQuestionResponseId?: number
  responseValue?: string | null
  metadata?: Record<string, any>
  hideText?: boolean
}

/**
 * Filters response options for a question based on answers from other questions
 * @param question - The question whose response options should be filtered
 * @param allAnswers - All answers from the Zustand store (arrays of responses)
 * @returns The question with filtered response options
 */
export const filterResponseOptions = (
  question: SurveyQuestion,
  allAnswers: Record<string, SurveyQuestionResponse[]>
): SurveyQuestion => {
  const questionId = Number(question.id)

  // Filter question 400's response options based on question 219's answers
  if (questionId === 400) {
    const question219Id = '219'
    const question219Responses = allAnswers[question219Id]

    if (!question219Responses || question219Responses.length === 0) {
      // If no answers from question 219, return question with no responses
      return {
        ...question,
        responses: [],
      }
    }

    // Get all selected response IDs from question 219
    const selectedResponseIds = question219Responses
      .map(response => response.surveyQuestionResponseId)
      .map(id => Number(id))
      .filter(id => !isNaN(id))

    if (selectedResponseIds.length === 0) {
      // If no valid response IDs, return question with no responses
      return {
        ...question,
        responses: [],
      }
    }

    // Filter question 400's responses to only include those that match question 219's selected response IDs
    const filteredResponses = question.responses?.filter(response =>
      selectedResponseIds.includes(response.id)
    )

    return {
      ...question,
      responses: filteredResponses || [],
    }
  }

  // Default: return question unchanged
  return question
}
